export default __webpack_public_path__ + "static/media/img-goals_2.817a7e1c.svg";